
import { GET_RTB_LOG, GET_RTB_LOG_BY_CALLER_ID } from './actionTypes';
import { getActionStatusName } from '@/store/helpers';

export const getRtbLogStatus = state => state.status[getActionStatusName(GET_RTB_LOG)] || {};

export const getRtbLogByCallerIdStatus = state => state.status[getActionStatusName(GET_RTB_LOG_BY_CALLER_ID)] || {};